import config from "@/services/Api-config";
import Vue, {VueConstructor} from "vue";
import configs from "../configs";
const setTitle = (title)=>{
  document.title=`${title} - ${configs.product.name}`;
};
declare module "vue/types/vue" {
  interface Vue {
    $setTitle: typeof setTitle
  }
}

Vue.use((vue:VueConstructor)=>{
  vue.prototype.$setTitle=setTitle;
});


